import Base from "@patternslib/patternslib/src/core/base";
import events from "@patternslib/patternslib/src/core/events";
import registry from "@patternslib/patternslib/src/core/registry";
import $ from "jquery";
import _ from "underscore";

import PatternUpload from "@plone/mockup/src/pat/upload/upload";
import RelatedItems from "@plone/mockup/src/pat/relateditems/relateditems";
import Modal from "@plone/mockup/src/pat/modal/modal";
// import "../../autotoc/autotoc";
// import "../../modal/modal";
import LinkTemplate from "./templates/link.xml";


var LinkType = Base.extend({
    name: "linktype",
    trigger: ".pat-linktype-dummy",
    defaults: {
        linkModal: null, // required
    },

    init: function () {
        this.linkModal = this.options.linkModal;
    },

    getEl: function () {
        return this.$el.find("input");
    },

    value: function () {
        return this.getEl().val().trim();
    },

    toUrl: function () {
        return this.value();
    },

    set: function (val) {
        this.getEl().val(val);
    },

    attributes: function () {
        return {
            "data-val": this.value(),
        };
    },
    updateRelatedItems: function () { },
});


var ExternalLink = LinkType.extend({
    name: "externallinktype",
    trigger: ".pat-externallinktype-dummy",
    init: function () {
        LinkType.prototype.init.call(this);
        this.getEl().on("change", function () {
            // check here if we should automatically add in http:// to url
            var val = $(this).val();
            if (new RegExp("https?://").test(val)) {
                // already valid url
                return;
            } else {
                $(this).val("https://" + val);
            }
        });
    },

    toUrl: function () {
        var value = this.value();
        if (value) {
            this.linkModal.$el.data('insertlink-type', 'external');
            document.querySelector('input[name="'+this.linkModal.$el.attr('name')+'.linktype"]').value = 'external';
            this.linkModal.$el.data('insertlink-uid', '');
            document.querySelector('input[name="'+this.linkModal.$el.attr('name')+'.uid"]').value = '';
            this.linkModal.$el.val(value);
            return value;
        }
        return null;
    },
});


var InternalLink = LinkType.extend({
    name: "internallinktype",
    trigger: ".pat-internallinktype-dummy",
    init: async function () {
        if (!this.getEl().length) {
            return;
        }
        LinkType.prototype.init.call(this);
        this.getEl().addClass("pat-relateditems");
        await this.createRelatedItems();
    },

    getEl: function () {
        return this.$el.find("input:not(.select2-input)");
    },

    createRelatedItems: async function () {
        if (!this.getEl().length) {
            return;
        }
        var options = this.linkModal.options.relatedItems;
        options.upload = false; // ensure that related items upload is off.
        this.relatedItems = new RelatedItems(this.getEl(), options);
        await events.await_pattern_init(this.relatedItems)
    },

    updateRelatedItems: async function (val) {
        if (!this.relatedItems) {
            // prevent toolbar from being rendered twice
            await this.createRelatedItems();
        }
        this.relatedItems.selectItem(val);
    },

    value: function () {
        var val = this.getEl().select2("data");
        if (val && typeof val === "object") {
            val = val[0];
        }
        return val;
    },

    toUrl: function () {
        var value = this.value();
        if (value) {
            var uid = value.UID;
            this.linkModal.$el.data('insertlink-type', 'internal');
            document.querySelector('input[name="'+this.linkModal.$el.attr('name')+'.linktype"]').value = 'internal';
            this.linkModal.$el.data('insertlink-uid', uid);
            document.querySelector('input[name="'+this.linkModal.$el.attr('name')+'.uid"]').value = uid;
            this.linkModal.$el.val(value.getURL);
            return value.getURL;
        }
        return null;
    },

    set: function (val) {
        var $el = this.getEl();
        $el.val(val).trigger("change");
        this.updateRelatedItems(val);
    },

    attributes: function () {
        var val = this.value();
        if (val) {
            return {
                "data-val": val.UID,
            };
        }
        return {};
    },
});


var UploadLink = LinkType.extend({
    name: "uploadlinktype",
    trigger: ".pat-uploadlinktype-dummy",
    /* need to do it a bit differently here.
       when a user uploads and tries to upload from
       it, you need to delegate to the real insert
       linke types */
    getDelegatedLinkType: function () {
        if (this.linkModal.linkType === "uploadImage") {
            return this.linkModal.linkTypes.image;
        } else {
            return this.linkModal.linkTypes.internal;
        }
    },
    toUrl: function () {
        return this.getDelegatedLinkType().toUrl();
    },
    attributes: function () {
        return this.getDelegatedLinkType().attributes();
    },
    set: function (val) {
        return this.getDelegatedLinkType().set(val);
    },
    load: function (element) {
        return this.getDelegatedLinkType().load(element);
    },
    value: function () {
        return this.getDelegatedLinkType().value();
    },
});


export default Base.extend({
    name: "insertlinkmodal",
    trigger: ".pat-insertlinkmodal",
    parser: "mockup",
    defaults: {
        linkTypes: [
            'internal',
            'upload',
            'external'
        ],
        initialLinkType: "internal",
        text: {
            insertHeading: "Insert Link",
            internal: "Internal",
            external: "External",
            upload: "Upload",
            externalText: "External URL (it should start with http:// or https://)",
            insertLinkHelp: "Specify the object to link to. It can be on this site already (Internal), an object you upload (Upload) or from an external site (External)."
        },
        linkTypeClassMapping: {
            internal: InternalLink,
            upload: UploadLink,
            external: ExternalLink
        },
        upload: {
            uploadMultiple: false,
            maxFiles: 1,
            showTitle: false,
        },
        relatedItems: {
            // UID attribute is required here since we're working with related items
            attributes: [
                "UID",
                "Title",
                "portal_type",
                "path",
                "getURL",
                "getIcon",
                "is_folderish",
                "review_state",
            ],
            batchSize: 20,
            basePath: "/",
            vocabularyUrl: null,
            width: 500,
            maximumSelectionSize: 1,
            placeholder: "Search for item on site...",
        },
    },

    template: function (data) {
        return _.template(LinkTemplate)(data);
    },

    init: async function () {
        var self = this;

        self.$el.data('insertlink-type', document.querySelector('input[name="'+self.$el.attr('name')+'.linktype"]').value);
        self.$el.data('insertlink-uid', document.querySelector('input[name="'+self.$el.attr('name')+'.uid"]').value);

        self.linkType = self.options.initialLinkType;
        self.linkTypes = {};
        self.modal = registry.patterns["plone-modal"].init(self.$el, {
            html: self.generateModalHtml(),
            content: null,
            buttons: ".plone-btn",
            reloadWindowOnClose: false,
            templateOptions: {
                classDialog: "modal-dialog modal-lg",
                reloadWindowOnClose: false,
            },
            actionOptions: { reloadWindowOnClose: false },
            backdropOptions: {
                zIndex: "1340",
                closeOnClick: false,
            },
        });
        self.modal.on("shown", (e) => {
            self.modalShown.apply(self, [e]);
        });

        var $el = $("<button class='btn btn-primary d-block'>Browse</div>").insertAfter(self.$el);
        $el.on('click', function(e){
            e.preventDefault();
            e.stopPropagation();
            self.show();
        });

        self.$el.on('change', function() {
            self.$el.data('insertlink-type', 'external');
            document.querySelector('input[name="'+self.$el.attr('name')+'.linktype"]').value = 'external';
            self.$el.data('insertlink-uid', '');
            document.querySelector('input[name="'+self.$el.attr('name')+'.uid"]').value = '';

            var val = self.$el.val();
            if (val) {
                if (new RegExp("https?://").test(val)) {
                    // already valid url
                    return;
                } else {
                    self.$el.val("https://" + val);
                }
            }
        });
    },

    generateModalHtml: function () {
        return this.template({
            options: this.options,
            upload: this.options.upload,
            text: this.options.text,
            insertHeading: this.options.text.insertHeading,
            uploadText: this.options.text.upload,
            insertLinkHelp: this.options.text.insertLinkHelp,
            internal: this.options.text.internal,
            external: this.options.text.external,
            linkTypes: this.options.linkTypes,
            externalText: this.options.text.externalText,
            // titleText: this.options.text.title,
            // altText: this.options.text.alt,
            cancelBtn: this.options.text.cancelBtn,
            insertBtn: this.options.text.insertBtn,
        });
    },

    initElements: async function () {
        var self = this;
        self.$button = $('.modal-footer input[name="insert"]', self.modal.$modal);

        /* load up all the link types */
        for (var index = 0; index < self.options.linkTypes.length; index++) {
            var type = self.options.linkTypes[index];
            var $container = $(".linkType." + type + " .main", self.modal.$modal);
            if ($container.length) {
                var instance = new self.options.linkTypeClassMapping[type](
                    $container,
                    {
                        linkModal: self,
                    }
                );
                await events.await_pattern_init(instance);
                self.linkTypes[type] = instance;
            }
        }

        $(".autotoc-nav a", self.modal.$modal).on("click", function () {
            var $fieldset = $("fieldset.linkType", self.modal.$modal).eq(
                $(this).index()
            );
            var classes = $fieldset[0].className.split(/\s+/);
            _.each(classes, function (val) {
                if (_.indexOf(self.options.linkTypes, val) !== -1) {
                    self.linkType = val;
                }
            });
        });

    },

    getLinkUrl: function () {
        // get the url, only get one uid
        return this.linkTypes[this.linkType].toUrl();
    },

    getValue: function () {
        return this.linkTypes[this.linkType].value();
    },

    // eslint-disable-next-line no-unused-vars
    modalShown: async function (e) {
        var self = this;
        await self.initElements();
        self.initData();
        // upload init
        if (self.options.upload) {
            self.$upload = $(".uploadify-me", self.modal.$modal);
            self.options.upload.relatedItems = $.extend(
                true,
                {},
                self.options.relatedItems
            );
            self.options.upload.relatedItems.selectableTypes = self.options.folderTypes;
            self.$upload.addClass("pat-upload");
            new PatternUpload(self.$upload, self.options.upload);
            self.$upload.on(
                "uploadAllCompleted",
                function (evt, data) {
                    self.linkTypes.internal.set(data.data.UID);
                    $(
                        "#" +
                            $("#tinylink-internal", self.modal.$modal).data("navref")
                    ).trigger("click");
                }.bind(self)
            );
        }

        self.$button.off("click").on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            self.linkType = self.modal.$modal.find("fieldset.active").data("linktype");
            if (self.linkType === "upload") {
                var patUpload = self.$upload.data().patternUpload;
                if (patUpload.dropzone.files.length > 0) {
                    patUpload.processUpload();
                    // eslint-disable-next-line no-unused-vars
                    self.$upload.on("uploadAllCompleted", function (evt, data) {
                        var counter = 0;
                        var checkUpload = function () {
                            if (counter < 5 && !self.linkTypes[self.linkType].value()) {
                                counter += 1;
                                setTimeout(checkUpload, 100);
                                return;
                            } else {
                                var href = self.getLinkUrl();
                                self.updateImage(href);
                                self.hide();
                            }
                        };
                        checkUpload();
                    });
                }
            }
            var href;
            try {
                href = self.getLinkUrl();
            } catch (error) {
                console.log(error);
                return; // just cut out if no url
            }
            if (!href) {
                return; // just cut out if no url
            }
            self.hide();
        });
        $('.modal-footer input[name="cancel"]', self.modal.$modal).on(
            "click",
            function (e) {
                e.preventDefault();
                self.hide();
            }
        );
        if (self.$el.val()){
            $("#"+$("#tinylink-"+self.linkType, self.modal.$modal).data("navref")
            ).trigger("click");
        }
    },

    show: function () {
        this.modal.show();
    },

    hide: function () {
        this.modal.hide();
    },

    initData: function () {
        var self = this;
        self.linkType = self.$el.data('insertlink-type');
        if (self.linkType === 'internal'){
            var uid = self.$el.data('insertlink-uid');
            if (uid){
                self.linkTypes[self.linkType].set(uid);
            }
        } else if (self.linkType === 'external'){
            self.linkTypes[self.linkType].set(self.$el.val());
        }
    },

    reinitialize: function () {
        /*
         * This will probably be called before show is run.
         * It will overwrite the base html template given to
         * be able to privde default values for the overlay
         */
        this.modal.options.html = this.generateModalHtml();
    },
});